import { useEffect, useState } from 'react';
import { adminUserService } from '../services';

function useVerifyToken(token) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    verifyToken();

    async function verifyToken() {
      setLoading(true);
      try {
        if (!token) {
          setLoading(false);
          return;
        }
        await adminUserService.verifyToken();
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    }
  }, [token]);

  return ({
    loading,
    error,
  });
}

export default useVerifyToken;
